

export default {
  name: 'ModalPolicy'
}
